import React from 'react'
import { Form, Radio, Select, Row, Col, Card } from 'antd'
import { useTranslation } from 'react-i18next'

const { Option } = Select

const ImageTextForm = ({ form, includeText, isImageBeingGenerated }) => {
  const { getFieldDecorator } = form

  const { t } = useTranslation()

  const textPositions = [
    { label: t('v5:top_left'), key: 'top-left' },
    { label: t('v5:top_center'), key: 'top-center' },
    { label: t('v5:top_right'), key: 'top-right' },
    { label: t('v5:center'), key: 'center' },
    { label: t('v5:bottom_left'), key: 'bottom-left' },
    { label: t('v5:bottom_center'), key: 'bottom-center' },
    { label: t('v5:bottom_right'), key: 'bottom-right' }
  ]

  const fontSizes = [
    { value: 'big', label: t('v5:big') },
    { value: 'medium', label: t('v5:medium') },
    { value: 'small', label: t('v5:small') }
  ]

  const fontTypes = [
    t('v5:font_retro'),
    t('v5:font_techy'),
    t('v5:font_neon'),
    t('v5:font_sketch'),
    t('v5:font_3d'),
    t('v5:font_comic_style'),
    t('v5:font_anime_style'),
    t('v5:font_illustration'),
    t('v5:font_hand_written'),
    t('v5:font_quirky'),
    t('v5:font_chalk_board')
  ]

  const fontStyles = [
    { value: 'regular', label: t('v5:regular') },
    { value: 'bold', label: t('v5:bold') },
    { value: 'italic', label: t('v5:italic') },
    { value: 'thin', label: t('v5:thin') }
  ]

  const textColors = [
    t('v5:color_vibrant'),
    t('v5:color_black_white'),
    t('v5:color_gold_script'),
    t('v5:color_rainbow_neon'),
    t('v5:color_gradient')
  ]

  return (
    <>
      {includeText && (
        <Card title={t('v5:text_options')} style={{ marginBottom: 16 }}>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                required={false}
                colon={false}
                label={t('v5:text_position')}
              >
                {getFieldDecorator('textPosition', {
                  initialValue: t('v5:top_left'),
                  rules: [
                    { required: true, message: t('v5:please_select_text') }
                  ]
                })(
                  <Radio.Group
                    buttonStyle="solid"
                    className="text-position-group"
                  >
                    {textPositions.map(pos => (
                      <Radio.Button
                        key={pos.key}
                        value={pos.key}
                        disabled={isImageBeingGenerated}
                      >
                        {pos.label}
                      </Radio.Button>
                    ))}
                  </Radio.Group>
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                required={false}
                colon={false}
                label={t('v4:font_size')}
              >
                {getFieldDecorator('fontSize', {
                  initialValue: t('v5:medium'),
                  rules: [
                    {
                      required: true,
                      message: t('v5:please_select_a_font_size')
                    }
                  ]
                })(
                  <Select disabled={isImageBeingGenerated}>
                    {fontSizes.map(size => (
                      <Option key={size.value} value={size.value}>
                        {size.label}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                required={false}
                colon={false}
                label={t('v5:font_style')}
              >
                {getFieldDecorator('fontStyle', {
                  initialValue: t('v5:regular'),
                  rules: [
                    {
                      required: true,
                      message: t('v5:please_select_a_font_style')
                    }
                  ]
                })(
                  <Select disabled={isImageBeingGenerated}>
                    {fontStyles.map(style => (
                      <Option key={style.value} value={style.value}>
                        {style.label}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                required={false}
                colon={false}
                label={t('v5:font_type')}
              >
                {getFieldDecorator('fontType', {
                  initialValue: t('v5:font_retro'),
                  rules: [
                    {
                      required: true,
                      message: t('v5:please_select_a_font_type')
                    }
                  ]
                })(
                  <Select disabled={isImageBeingGenerated}>
                    {fontTypes.map(type => (
                      <Option key={type} value={type.toLowerCase()}>
                        {type}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                required={false}
                colon={false}
                label={t('v5:text_color')}
              >
                {getFieldDecorator('textColor', {
                  initialValue: t('v5:color_vibrant'),
                  rules: [
                    {
                      required: true,
                      message: t('v5:please_select_a_text_color')
                    }
                  ]
                })(
                  <Select disabled={isImageBeingGenerated}>
                    {textColors.map(color => (
                      <Option key={color} value={color.toLowerCase()}>
                        {color}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>
        </Card>
      )}

      <p className="image-generation-note">
        {t('v5:note_that_ai_generated_content_may_not_always_be_accurate')}
      </p>
      <Form.Item label={t('v5:number_of_images')}>
        {getFieldDecorator('numImages', {
          initialValue: '1',
          rules: [{ required: true, message: t('v5:please_select_of_image') }]
        })(
          <Radio.Group buttonStyle="solid" className="text-position-group">
            {[1, 2, 3, 4].map(num => (
              <Radio.Button
                key={num}
                value={num.toString()}
                disabled={isImageBeingGenerated}
              >
                {num}
              </Radio.Button>
            ))}
          </Radio.Group>
        )}
      </Form.Item>
    </>
  )
}

export default ImageTextForm
